import { enableAlert } from "../constants/values";

export function customAlert(msg) {
  if (enableAlert) {
    alert(msg);
  }
}
